import { useUser } from "apps/web/src/utils/tokens";
import React from "react";
import { useEditRecipeFullMutation, useEditRecipePartialMutation, useRecipeEditDialogQuery } from "../../../types";
import LoadingBackdrop from "../../universal/LoadingBackdrop";
import { RecipeFormState } from "../Form/utils";
import { RecipeEditContent } from "./RecipeEditContent";

interface RecipeEditProps {
  onClose: () => void;
  onEdit: () => void;
  recipeId: string;
  onDuplicate: () => void;
  forStaff?: boolean;
  readonly?: boolean;
  onScaleAndCreateNewRecipe: (state: RecipeFormState) => void;
}

export const RecipeEdit = ({ onClose, onEdit, recipeId, onDuplicate, forStaff, readonly, onScaleAndCreateNewRecipe }: RecipeEditProps) => {
  const user = useUser();
  const { data, loading } = useRecipeEditDialogQuery({
    variables: {
      id: recipeId,
    },
  });

  const isOrgGroupReadonly = Boolean(data?.recipe?.orgGroup) && Boolean(user) && user?.id !== data?.recipe.owner.id;

  const [editRecipeFull, { loading: savingFull }] = useEditRecipeFullMutation({
    onCompleted: () => {
      onEdit();
    },
  });

  const [editRecipePartial, { loading: savingPartial }] = useEditRecipePartialMutation({
    onCompleted: () => {
      onEdit();
    },
  });

  const isLoading = savingFull || savingPartial || loading || !data;

  return isLoading ? (
    <LoadingBackdrop open={isLoading} onClose={onClose} />
  ) : (
    <RecipeEditContent
      onClose={onClose}
      onEditPartial={input => editRecipePartial({ variables: { input } })}
      onEditFull={input => editRecipeFull({ variables: { input } })}
      recipe={data.recipe}
      onDuplicate={onDuplicate}
      forStaff={forStaff}
      readonly={readonly || isOrgGroupReadonly}
      onScaleAndCreateNewRecipe={onScaleAndCreateNewRecipe}
    />
  );
};
